import { render } from "./LogHistory.vue?vue&type=template&id=667ea235"
import script from "./LogHistory.vue?vue&type=script&lang=js"
export * from "./LogHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__